import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './overviewstatusselection.scss'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// import components
import Modal from '../../components/Modal'

// Actions
import { triggerPopup } from '../../../actions/backdrop'
import { openOverlay } from '../../../actions/common'

// Overlays
import ProductionStatusOverlay from '../../overlays/ProductionStatusOverlay'
import DeliveryStatusOverlay from '../../overlays/DeliveryStatusOverlay'
import PickupStatusOverlay from '../../overlays/PickupStatusOverlay'

import { ModalIcons } from '../../elements/icons'

// Elements
import Button from '../../elements/button'

class OverviewStatusSelection extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      isLoading: false
    }
    this.openOverlay = this.openOverlay.bind(this)
  }

  openOverlay (overlay) {
    this.props.openOverlay(overlay)
    this.setState({ overviewstatusmodal: false })
    this.props.triggerPopup(false)
  }

  render () {
    if (!(hasSubscriptionPermission(this.props.auth, 30) && !hasAccess([4], this.props.auth.user.UserType))) return null
    const openOverviewStatusModal = () => {
      this.setState({ overviewstatusmodal: true })
      this.props.triggerPopup(true)
    }
    const closeOverviewStatusModal = () => {
      this.props.triggerPopup(false)
      this.setState({
        overviewstatusmodal: false
      })
    }
    return (
      <div className='overviewstatus-section'>
        <Button spacing={0} size='m' style='link' labelText={translation('13052')} onClick={openOverviewStatusModal} />
        {this.state.overviewstatusmodal && (
          <div className='overviewstatus_modal'>
            <Modal show={this.state.overviewstatusmodal} router={this.props.router} onClose={closeOverviewStatusModal} header={translation('16720')} overflowHidden={this.state.overflowHidden}
              icon={ModalIcons.Repport_Data}>
              <div className='overviews'>
                <Button style='link' labelText={translation('16839')} onClick={() => this.openOverlay('PickupStatusOverlay')} />
                <Button style='link' labelText={translation('16719')} onClick={() => this.openOverlay('ProductionStatusOverlay')} />
                <Button style='link' labelText={translation('16721')} onClick={() => this.openOverlay('DeliveryStatusOverlay')} />
              </div>
            </Modal>
          </div>
        )}
        <ProductionStatusOverlay />
        <DeliveryStatusOverlay />
        <PickupStatusOverlay />
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  triggerPopup,
  openOverlay
})(OverviewStatusSelection)



// WEBPACK FOOTER //
// ./src/app/shared/components/OverviewStatusSelection/index.js